// extracted by mini-css-extract-plugin
export default {"container":"pay-qr-modal_container__CrvHd"};